
import { AdjustmentReport, GenericApiResponse, InventoryAdjustment, ProductsByWarehouse } from 'interfaces';
import {  post,get } from 'services/services.methods';

import { AdjustmenPath, inventoryAdjustmenPath, ProductsPaths } from "services/services.paths";


export const postInventoryAdjustment = async ( inventorAdjustment: InventoryAdjustment ) => {
    const responseInvetory = await post<any>(inventoryAdjustmenPath.post, inventorAdjustment);
    return responseInvetory.data;
    
};

export const getProductsByWarehouseInventory = async (warehouseId: string) => {
  const response = await get<ProductsByWarehouse[]>(
    inventoryAdjustmenPath.getProductInvetoryAd + `/${warehouseId}`
  );
  return response.data;
};





export const getlistAdjustament = async (
  purchaseParams: { adjustmentId: number; dateFrom: string; dateTo: string; warehouseId: number }
): Promise<GenericApiResponse<AdjustmentReport[]>> => {
  
  const url = `${AdjustmenPath.post}?adjustmentId=${purchaseParams.adjustmentId}&dateFrom=${purchaseParams.dateFrom}&dateTo=${purchaseParams.dateTo}&warehouseId=${purchaseParams.warehouseId}`;
  const response = await post<AdjustmentReport[]>(AdjustmenPath.post, purchaseParams);


  return response;
};

